exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-058e72bc]  .dialog_box{border-radius:10px}.box[data-v-058e72bc]  .dialog_box .el-dialog__header{border-radius:10px 10px 0 0;background:#ecf4ff;color:#282828;font-weight:600;font-size:22px}.box .from_box[data-v-058e72bc]{padding:0 80px}[data-v-058e72bc] .el-form-item__label{font-weight:600;font-size:16px;color:#282828}.el-input[data-v-058e72bc],.el-select[data-v-058e72bc]{width:343px;height:32px;background:#fff;border-radius:7px}", ""]);

// exports
